module.exports = __webpack_public_path__ + "img/ES.5c7e93a7.png";